import React, { Component } from 'react';

import zeroOdour from './zero.jpg'
import oneOdour from './one.jpg'
import twoOdour from './two.jpg'
import threeOdour from './three.jpg'
import fourOdour from './four.jpg'
import fiveOdour from './five.jpg'
import sixOdour from './six.jpg'
import sevenOdour from './seven.jpg'

import { ReactComponent as ChevronLeft } from '../../icons/chevron-left-solid.svg';
import { ReactComponent as ChevronRight } from '../../icons/chevron-right-solid.svg'

const intensityScale = [
    {
        srcImage: zeroOdour,
        description: `Use the buttons below to change the odour strength.`
    },
    {
        srcImage: oneOdour,
        description: `I haven't noticed any smell.`
    },
    {
        srcImage: twoOdour,
        description: `I noticed a faint smell outside, I wonder what that is.`
    },
    {
        srcImage: threeOdour,
        description: `I noticed a smell outside but it doesn't really change what I do.`
    },
    {
        srcImage: fourOdour,
        description: `I can't use my outside areas, if I keep the windows closed it's OK inside.`
    },
    {
        srcImage: fiveOdour,
        description: `I can smell the odour inside my house.`
    },
    {
        srcImage: sixOdour,
        description: `I can't use my house for certain activities because of the smell.`
    },
    {
        srcImage: sevenOdour,
        description: `I don't want to be at home because of the odour.`
    }
]

function IntensityScale({ intensity, onChange }) {

    const options = [1, 2, 3, 4, 5, 6, 7]
        .map(i => {
            let itemClass = 'intensity-item'
            if (i === intensity) {
                itemClass = itemClass + ` active-${i}`
            }
            const triggerChange = () => {
                const val = i;
                if (onChange) {
                    onChange(val);
                }
            }
            return (<button onClick={triggerChange} key={i} className={itemClass}></button>)
        })
    return (<div className="intesity-scale">
        {options}
    </div>)
}

class OdourIntensity extends Component {
    constructor() {
        super();
        this.makeWeaker = () => {
            const { intensity, onChange } = this.props
            if (intensity > 0) {
                onChange({ intensity: intensity - 1 });
            }
        }

        this.makeStronger = () => {
            const { intensity, onChange } = this.props
            if (intensity < intensityScale.length - 1) {
                onChange({ intensity: intensity + 1 });
            }
        }
    }

    render() {
        const { intensity, onChange } = this.props
        const chosenIntensity = intensityScale[intensity]
        return (<div>
            <div className="image-wrapper">
                <img alt={chosenIntensity.description} src={chosenIntensity.srcImage} className="odour-image"></img>
                <div className="question-highlight">{chosenIntensity.description}</div>
            </div>
            <IntensityScale onChange={(e) => onChange({ intensity: e })} intensity={intensity} ></IntensityScale>
            <div className="intensity-actions">
                <button
                    style={{ float: 'left' }}
                    disabled={intensity === 0} onClick={this.makeWeaker}>
                    <ChevronLeft style={{ marginLeft: '-2px' }} className='action-icon' />
                    WEAKER</button>
                <button
                    style={{ float: 'right' }}
                    disabled={intensity === intensityScale.length - 1} onClick={this.makeStronger}>
                    STRONGER
                    <ChevronRight style={{ marginRight: '-2px' }} className='action-icon' />
                </button>
            </div>
        </div>)
    }
}
export default OdourIntensity